<template>
    <div>
        <ion-grid>
            <ion-row class="search-view">
                <ion-col size="2.5">
                    <ion-label>Branch Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.branch" placeholder="branch name"/>
                    </div>
                </ion-col>
                <ion-col size="2.5">
                    <ion-label>Station Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.stationName" placeholder="branch name"/>
                    </div>
                </ion-col>
                <ion-col  size="2.5">
                    <ion-label>Select Charger Type</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            v-model="selectedCharger"
                            @ionChange="changeCharger($event)"
                            placeholder="Select Charger"
                            interface="action-sheet"
                        >
                            <ion-select-option
                                v-for="(charger, index) in chargersList"
                            :key="index"
                            :value="charger.chargerId"
                            >{{charger.chargerTypeDescription}}</ion-select-option>
                        </ion-select>
                        <select
                            @change="changeCharger($event)"
                            class="input-select select-web"
                            v-model="selectedCharger"
                            placeholder="Select Status"
                        >
                            <option
                            v-for="(charger, index) in chargersList"
                            :key="index"
                            :value="charger.chargerId"
                            >{{ charger.chargerTypeDescription }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col  size="2.5">
                    <ion-label>Select Output</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            v-model="selectedOutput"
                            @ionChange="changeOutput($event)"
                            placeholder="Select Charger"
                            interface="action-sheet"
                        >
                            <ion-select-option
                                v-for="(output, index) in this.outputs"
                            :key="index"
                            :value="output.outputId"
                            >{{output.outputName}}</ion-select-option>
                        </ion-select>
                        <select
                            @change="changeOutput($event)"
                            class="input-select select-web"
                            v-model="selectedOutput"
                            placeholder="Select Status"
                        >
                            <option
                            v-for="(output, index) in this.outputs"
                            :key="index"
                            :value="output.outputId"
                            >{{ output.outputName }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col size="12" size-md="2">
                <ion-label>Error Code</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        :value="errCode"
                        @ionChange="errCode = $event.target.value"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(errCode, index) in this.errorCodeList"
                            :key="index"
                            :value="errCode"
                        >{{ errCode }}</ion-select-option>
                        </ion-select>

                        <select
                        class="input-select select-web"
                        v-model="errCode"
                        >
                        <option
                            v-for="(errCode, index) in this.errorCodeList"
                            :key="index"
                            :value="errCode"
                        >{{ errCode }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col size="2.5">
                    <ion-label>From Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportFrom"
                        :typeable="true"
                        :lowerLimit ="sixMonthsAgo"
                        :upperLimit ="currentDate"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportFrom" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select From Date"
                        @change="fromDateChanged($event)"
                        :value = reportFrom
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        :typeable="true"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col size="2.5">
                    <ion-label>To Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportTo"
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="maxDate"
                        :typeable="true"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportTo" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select To Date"
                        @change="reportTo = $event.target.value"
                        :value = reportTo
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col size="2.5" v-if="displayDownloadOption">
                    <div class="export-report">
                        <ion-label style="font-size: 14px;">Export Report</ion-label>
                        <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="reportType"
                                @ionChange="changeReportType($event)"
                                placeholder="Export Report"
                                interface="action-sheet"
                            >
                                <ion-select-option
                                    v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</ion-select-option>
                            </ion-select>

                            <select
                                @change="changeReportType($event)"
                                class="input-select select-web"
                                v-model="reportType"
                                placeholder="Export Report"
                            >
                                <option
                                v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</option>
                            </select>
                        </div>
                    </div>
                </ion-col>
                <ion-col size="2">
                    <div class="btn-srch-clr">
                        <ion-button class="btn-search " @click="searchReport">Search</ion-button>
                        <ion-button class="btn-clear " @click="clearFields">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                    </div>
                </ion-col>
            </ion-row>
            <!-- <ion-row v-if="displayDownloadOption">
                <ion-col size="6"></ion-col>
                <ion-col size="6">
                    <div class="export-report">
                        <ion-label style="font-size: 14px;">Export Report</ion-label>
                        <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="reportType"
                                @ionChange="changeReportType($event)"
                                placeholder="Export Report"
                                interface="action-sheet"
                            >
                                <ion-select-option
                                    v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</ion-select-option>
                            </ion-select>

                            <select
                                @change="changeReportType($event)"
                                class="input-select select-web"
                                v-model="reportType"
                                placeholder="Export Report"
                            >
                                <option
                                v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</option>
                            </select>
                        </div>
                    </div>
                </ion-col>
            </ion-row><br> -->
            
            <ion-row class="list-view" v-if="statusReportDetails">
                <ion-col >
                    <ion-row class="list-head">
                        <ion-col size="1" >
                        <ion-label>S.No</ion-label>
                        </ion-col>
                        <ion-col size="2" >
                        <ion-label>Station Name</ion-label>
                        </ion-col>
                        <ion-col size="2" >
                        <ion-label>Charger ID</ion-label>
                        </ion-col>
                        <!-- <ion-col size="1" >
                        <ion-label>Output No</ion-label>
                        </ion-col> -->
                        <ion-col size="1" >
                        <ion-label>Output Name</ion-label>
                        </ion-col>
                        <ion-col size="2" >
                        <ion-label>Charger Type</ion-label>
                        </ion-col>
                        
                        <ion-col size="2" >
                        <ion-label>Time</ion-label>
                        </ion-col>
                        <ion-col size="2" >
                        <ion-label>Error Code</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.chargerStatusReportData" :key="index">
                        <ion-col size="12" size-md="1">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ report.stationName }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ report.chargeboxId }}</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="1">
                        <ion-label>{{ report.outputNo }}</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                        <ion-label>{{ report.outputNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ report.chargerType }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ report.timestamp }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{ report.errorCode }}</ion-label>
                        </ion-col>
                    </ion-row>
                    
                </ion-col>
            </ion-row>
        </ion-grid>

        <div>
            <ion-grid>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="ion-text-center no-records">
                    <ion-label class="pagination-info txt-color">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-if="statusReportDetails">
                    <ion-col size="12" size-md="5"  >
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <!-- <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div> -->
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..."></ion-loading>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>        
</template>

<script>
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner, IonLoading} from "@ionic/vue";
import { defineComponent } from "vue";
import { receiptOutline, refresh } from 'ionicons/icons';
import datepicker from 'vue3-datepicker';
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";
import { ValidationUtils } from "../../util/validation-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import jsonToCsvExport from "json-to-csv-export";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";

export default defineComponent({
    name: 'chargerStatusReport',
    components:{
        IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonIcon, IonGrid, IonRow, IonCol, IonSpinner, IonButton, IonLabel, datepicker, IonInput, IonSelect, IonSelectOption,IonLoading
    },
    data(){
        return{
            isLoading: false,
            receiptOutline,
            refresh,
            // loaderTab: true,
            reportFrom: new Date(),
            reportTo: new Date(),
            configDays: 0,
            configMonths: 0,
            // Calculate the minimum and maximum dates
            // minDate: this.calculateMinDate(),
            maxDate: new Date(), // Current date
            // The current date
            currentDate: new Date(),
            // Date 6 months ago
            sixMonthsAgo: new Date(),
            pageData: [],
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            branchId: "",
            mobile: '',
            branchList: [],
            userBasedReport: [],
            overAllReport: [],
            userBasedPageData: [],
            overAllPageData: [],
            reportTypes: [
                {
                    "name" : "PDF",
                    "code" : "pdf"
                },
                {
                    "name" : "CSV",
                    "code" : "csv"
                }
            ],
            reportType: "",
            displayDownloadOption: false,
            configValue: [],
            chargerStatusReportOverAllData: "",
            chargerStatusReportData: "",
            branchDetails: "",
            chargeboxId: '',
            statusReportDetails: false,
            chargersList : [],
            userRoleId: "",
            selectedCharger: "0",
            outputs: [
                { outputId: "0", outputName: "All Outputs" }
            ],
            selectedOutput: "0",
            chargerName: "",
            outputName: "",
            errCode: "",
            errorCodeList: []
        }
    },
    async mounted() {
        this.userRoleId = window.localStorage.getItem("user.roleId");
        this.branchDetails = JSON.parse(localStorage.getItem('branchInfoFromReportList'));
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
        await this.chargerListForStatusReport()
        await this.searchReport();
        this.errorCodeList = await new EVCStationReservationService().getErroList();
    },
    
    methods: {
        async getDateAndMonth() {
            this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
            this.configDays = this.configValue[0].description;
            this.configMonths = this.configValue[1].description
        },
        calculateMinDate() {
            const date = new Date();
            date.setMonth(date.getMonth() - 6);
            // alert(date)
            return date;
        },
        fromDateChanged(event) {
            // alert(event)
        },
        // Helper function to calculate a date 'n' days ago
        async getDateDaysAgo(days) {
            const date = new Date();
            date.setDate(date.getDate() - days);

            this.reportFrom =  date;
        },

        // Helper function to calculate the date 'n' months ago
        async getDateMonthsAgo(months) {
            const date = new Date();
            date.setMonth(date.getMonth() - months);
            this.sixMonthsAgo = date;
        },
        changeDateFormat(dateValue) {
            // return moment(dateValue).format('DD/MMM/YYYY HH:mm')
            return dateValue;
        },
        async chargerListForStatusReport() {
            // this.chargersList = await new CorporateService().getChargersListForStatusReport(this.branchDetails.branchId) 
            this.chargersList = await new CorporateService().getChargerStatusDataForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId
            });
            if(this.chargersList.length == 1) {
                this.selectedCharger = this.chargersList?.[0]?.chargerId;
                this.chargersList.filter((val) => {
                    if(val.chargerId == this.selectedCharger) {
                        
                        this.chargerName = val.chargerTypeDescription;
                    }
                });
                this.outputs = await new CorporateService().getChargerOutputListForReport({
                    branchId: this.branchDetails.branchId,
                    stationId: this.branchDetails.stationId,
                    chargerId: this.selectedCharger,
                });
                this.selectedOutput = this.outputs?.[0]?.outputId;
                this.outputs.filter((val) => {
                    if(val.outputId == this.selectedOutput) {
                        
                        this.outputName = val.outputName;
                    }
                });
            } else {
                this.selectedCharger = this.chargersList?.[0]?.chargerId;
                this.selectedOutput = this.outputs?.[0]?.outputId;
                this.chargersList.filter((val) => {
                    if(val.chargerId == this.selectedCharger) {
                        
                        this.chargerName = val.chargerTypeDescription;
                    }
                });
                this.outputs.filter((val) => {
                    
                    if(val.outputId == this.selectedOutput) {
                        
                        this.outputName = val.outputName;
                    }
                });
            }
        },  
        async changeBranchName(event) {
            this.branchId = event.target.value;
        },
        async changeCharger(event) {
            this.selectedCharger = event.target.value;
            this.chargersList.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs = await new CorporateService().getChargerOutputListForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId,
                chargerId: this.selectedCharger,
            });
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.statusReportDetails = false;
            this.displayDownloadOption = false;
        }, 
         changeOutput(event) {
            this.selectedOutput = event.target.value;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.statusReportDetails = false;
            this.displayDownloadOption = false;
        },
         async searchReport() {
            // this.loaderTab = true;
            this.isLoading = true
            this.pageNo = 1;
            this.pageRecords = 10;
            this.reportType = "";
            this.displayDownloadOption = false;
            this.statusReportDetails = false;
            let dateRange =  (new Date(this.reportTo) - new Date(this.reportFrom));
            let dateRangeBetween = dateRange/(1000*60*60*24)
            if(this.reportFrom &&
                this.reportTo &&
                new Date(this.reportFrom) > new Date(this.reportTo)){
                // this.loaderTab = false;
                this.isLoading = false;
                new ToastUtils().presentToast("Please select correct date range of Reoprt. From date should less than To date");
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                // this.loaderTab = false;
                this.isLoading = false;
            } else if(dateRangeBetween > this.configDays) {
                // this.loaderTab = false;
                this.isLoading = false;
                new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ this.configDays + " days");
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                // this.loaderTab = false;
                this.isLoading = false
            } else {
                try {
                    this.norecordsfound = false;
                    this.chargerStatusReportOverAllData = await new CorporateService().getTransactionAndStatusReportQuery({
                        branchId: this.branchDetails.branchId,
                        reportCode: this.branchDetails.reportCode,
                        reportId: this.branchDetails.reportId,
                        fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                        toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                        stationId: this.branchDetails.stationId,
                        chargerId: this.selectedCharger,
                        outputId: this.selectedOutput,
                        chargerType: this.chargerName,
                        outputName: this.outputName,
                        branchName: this.branchDetails.branch,
                        stationName: this.branchDetails.stationName,
                        errorCode: this.errCode
                    });
                    // console.log(this.chargerStatusReportOverAllData)
                    this.totalkWh = this.chargerStatusReportOverAllData.totalKwh;
                    if(this.chargerStatusReportOverAllData.reportData.length > 0) {
                        this.totalRecords = this.chargerStatusReportOverAllData.reportData.length;
                        (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                        )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                            this.totalRecords,
                            this.pageRecords
                        ));
                        let to = this.pageRecords*this.pageNo;
                        let from = (this.pageRecords * (this.pageNo -1));
                        this.chargerStatusReportData = this.chargerStatusReportOverAllData.reportData.slice(from, to)
                        this.statusReportDetails = true
                        // console.log("374 " + this.chargerStatusReportData)
                        this.displayDownloadOption = true;
                        this.norecordsfound = false;
                    } else {
                        this.statusReportDetails = false;
                        this.norecordsfound = true;
                        this.displayDownloadOption = false;
                    }
                    // this.loaderTab = false;
                    this.isLoading = false;
                } catch(error) {
                    // this.loaderTab = false;
                    this.isLoading = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }              
                
            }
        },
        async changeReportType(event) {
            let type = event.target.value;
            if(type == 'pdf') {
                this.downloadPdf(this.chargerStatusReportOverAllData)
            } else if(type == 'csv') {
                this.downloadCSV(this.chargerStatusReportOverAllData)
            }
        },
        async downloadCSV(reportDate) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                    // console.log(JSON.stringify(reportDate))
                    jsonToCsvExport({ data: reportDate.downloadingReportData.csv,headers: reportDate.reportHeaders.csvHeader, filename: "ChargerStatusReport_"+moment().format("DD/MM/YYYY")+".csv" })  // Automatically triggers download
                    this.reportType = ""
                } catch (error) {
                    console.error('Error generating CSV:', error);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async downloadPdf(data) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                    // this.loaderTab = true;
                    this.isLoading = true;
                    const response = await new CorporateService().downloadUsagePdfReport(data, this.branchDetails.branchId, this.branchDetails.reportCode);
                    // Create a URL for the blob (PDF file)
                    const pdfBlob = response.data;
                    const pdfUrl = window.URL.createObjectURL(pdfBlob);
                    var a = document.createElement("a");
                    a.href = pdfUrl;
                    a.setAttribute("download", "ChargerStatusReport_"+moment().format("DD/MM/YYYY")+".pdf");
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    // this.loaderTab = false;
                    this.isLoading = false;
                    this.reportType = ""
                } catch(error) {
                    // this.loaderTab = false;
                    this.isLoading = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async clearFields() {
            this.reportTo = new Date();
            await this.getDateDaysAgo(this.configDays)
            await this.getDateMonthsAgo(this.configMonths)
            this.searchReport();
            this.reportType = ""

            this.selectedCharger = "0";
            this.selectedOutput = "0";
            this.chargerName = "All Charger Type"
            this.outputName = "All Outputs"
            this.errCode = ""
            this.outputs = [{ outputId: "0", outputName: "All Outputs" }];
            this.statusReportDetails = false;
            this.displayDownloadOption = false;
            this.norecordsfound = false;
            this.searchReport();
        },
        async loadPage(page) {
            // localStorage.setItem("cpoReservationPage", page);
            // alert(page+ "--"+this.totalRecords+"--"+this.pageRecords)
            // this.loaderTab = true;
            this.isLoading = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let to = this.pageRecords*page;
            let from = (this.pageRecords * (page -1));            
            this.chargerStatusReportData = this.chargerStatusReportOverAllData.reportData.slice(from, to);
            // this.loaderTab = false;
            this.isLoading = false;
        },
    },
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
ion-loading.custom-loading {
    --background: #d0cbcb;
    --spinner-color: #0bc954;
    color: #1a1b1c;
    --height: 7%;
}
.btn-srch-clr{
    margin-top: 22px;
}
.export-report{
    width: 100%;
}
.totalSection{
    /* background-color: #ededed; */
    margin-top: 20px;
    font-weight: bold;
}
.ext-link{
    color: black;
    cursor: auto;
}
.no-records{
    margin-top: 100px;
}
.txt-color{
    font-size: 16px;
}
</style>
